module.exports = __webpack_public_path__ + "img/mens-back-tattoos-of-abstract-deer-design.jpg";